document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const image = gallery.querySelector('.primary-media img');
    const buttons = gallery.querySelectorAll('[data-gallery-image]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      image.src = button.dataset.galleryImage;
      image.alt = button.dataset.galleryAlt || image.alt;
      buttons.forEach((item) => item.classList.toggle('is-selected', item === button));
    }));
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const data = section.querySelector('[data-variants]');
    if (!data) return;

    let variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (error) {
      return;
    }

    const optionGroups = Array.from(section.querySelectorAll('[data-option-group]'));
    const optionNames = optionGroups.map((group) => group.dataset.optionGroup);
    const choices = {};
    const selectedButtons = section.querySelectorAll('.option-button.is-selected');
    selectedButtons.forEach((button) => {
      choices[button.dataset.optionName] = button.dataset.optionValue;
    });

    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: window.veryllaCurrency || 'GBP'
    }).format(cents / 100);

    const getVariantOptions = (variant) => variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);

    const updateSelection = () => {
      const match = variants.find((variant) => getVariantOptions(variant).every((value, index) => choices[optionNames[index]] === value));
      if (!match) return;

      section.querySelector('[data-variant-input]').value = match.id;
      section.querySelector('[data-price]').textContent = money(match.price);
      section.querySelector('[data-button-price]').textContent = money(match.price);
      section.querySelector('[data-selection-summary]').textContent = match.title || match.name;
      section.querySelectorAll('[data-option-label]').forEach((label) => {
        const optionName = label.dataset.optionLabel;
        const choice = Object.keys(choices).find((key) => key.toLowerCase().replace(/[^a-z0-9]+/g, '-') === optionName);
        if (choice) label.textContent = choices[choice];
      });
    };

    section.querySelectorAll('.option-button').forEach((button) => button.addEventListener('click', () => {
      choices[button.dataset.optionName] = button.dataset.optionValue;
      section.querySelectorAll(`[data-option-name="${button.dataset.optionName}"]`).forEach((item) => item.classList.toggle('is-selected', item === button));
      updateSelection();
    }));

    section.querySelectorAll('[data-offer-card]').forEach((card) => card.addEventListener('click', () => {
      section.querySelectorAll('[data-offer-card]').forEach((item) => item.classList.toggle('is-selected', item === card));
      const radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      const quantity = section.querySelector('[data-quantity-input]');
      if (quantity) quantity.value = card.dataset.quantity || '1';
    }));

    updateSelection();
  });
});

